import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private _isOnlineSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public isOnline$ = this._isOnlineSubject.asObservable();

  constructor() { }

  public setIsOnlineValue(value) {
    this._isOnlineSubject.next(value);
  }

}
